import styled from 'styled-components';
var GroupContainer = styled.div.withConfig({
  displayName: "RepeatableFieldstyle__GroupContainer",
  componentId: "sc-10h6cu8-0"
})(["display:flex;align-items:center;width:100%;"]); // TODO: Use vignettes to add slide

var AddField = styled.div.withConfig({
  displayName: "RepeatableFieldstyle__AddField",
  componentId: "sc-10h6cu8-1"
})(["cursor:pointer;"]);
export { GroupContainer, AddField };